<template>
  <Btn
    v-bind="$attrs"
    class="FieldBtn sm ib"
    v-on="$listeners">
    <slot />
  </Btn>
</template>

<script>
export default {}
</script>

<style lang="scss">
.FieldBtn {
  bottom: 0.6rem;
  margin-left: $grid-unit-half;
  position: absolute;
  right: 0.5rem;
  z-index: 1;
}

.Field.type-textarea {
  .FieldBtn {
    bottom: 1.5rem;
    right: 0.5rem;
  }
}
</style>
